import privacy_policy from "./privacy_policy"
import user_agreement from "./user_agreement"
let legal = {
  privacy_policy,
  user_agreement
}
export default legal


// WEBPACK FOOTER //
// ./src/assets/lang/zh/new_legal/index.js